import React, { useState, useEffect, forwardRef } from "react";
import { useTranslation } from "react-i18next";
// Components
import {
  GraphicContainer,
  GraphicRotateDiv,
  HeaderDiv,
  GraphicTitle,
  LegendDiv,
  LegendColorDiv,
  GraphicSizeDiv,
  AxisX,
  HeatMapStyled,
} from "./styles";

const FrequencyPlot = forwardRef(({ recordings }, ref) => {
  const [positions, setPositions] = useState([]);
  const [gesturesLabels, setGesturesLabels] = useState([]);
  const [gesturesValues, setGesturesValues] = useState([]);
  const [t] = useTranslation("global");

  useEffect(() => {
    let frequenciesInputs = [];
    let gestures = [];
    let processedData = {};

    recordings.forEach((entry, index) => {
      frequenciesInputs.push(index + 1);
      const frequencies = entry.frequencies || {};
      for (const key in frequencies) {
        if (!gestures.includes(key)) gestures.push(key);
        if (!processedData[key]) processedData[key] = [];
      }
    });

    recordings.forEach((entry, index) => {
      const frequencies = entry.frequencies || {};

      if (!Boolean(Object.keys(frequencies).length)) {
        for (const gesture of gestures) {
          processedData[gesture].push(0);
        }
      }

      for (const key in frequencies) {
        processedData[key].push(frequencies[key]);
      }

      const currentIndex = index + 1;

      for (const key in processedData) {
        if (processedData[key].length !== currentIndex) {
          processedData[key].push(0);
        }
      }
    });

    let gesturesToSave = [];
    for (const gesture of gestures) {
      gesturesToSave.push(processedData[gesture]);
    }

    setPositions(frequenciesInputs);
    setGesturesLabels(gestures);
    setGesturesValues(gesturesToSave);
    return () => {
      setPositions([]);
      setGesturesLabels([]);
      setGesturesValues([]);
    };
  }, [recordings]);

  const getColorFromRatio = (ratio) => {
    const r1 = 247,
      g1 = 251,
      b1 = 255;
    const r2 = 8,
      g2 = 48,
      b2 = 107;
    const t = ratio;
    const r = Math.round(r1 + (r2 - r1) * t);
    const g = Math.round(g1 + (g2 - g1) * t);
    const b = Math.round(b1 + (b2 - b1) * t);
    return `rgb(${r},${g},${b})`;
  };

  return (
    <GraphicContainer ref={ref}>
      <GraphicRotateDiv>
        <HeaderDiv>
          <GraphicTitle>{t("reports.frequencyGraphic.title")}</GraphicTitle>
        </HeaderDiv>
        <LegendDiv>
          <LegendColorDiv margin="0 5px 0 0" color="rgb(247, 251, 255)" border />
          <p>0</p>
          <LegendColorDiv margin="0 5px 0 10px" color="rgb(128, 150, 181)" />
          <p>10</p>
          <LegendColorDiv margin="0 5px 0 10px" color="rgb(8, 48, 107)" />
          <p>19</p>
        </LegendDiv>
        <GraphicSizeDiv align={positions.length >= 25 ? "left" : "center"}>
          <HeatMapStyled
            data={gesturesValues}
            xLabels={positions}
            yLabels={gesturesLabels}
            xLabelsStyle={() => ({
              margin: "1px",
              fontSize: "16px",
            })}
            yLabelsStyle={() => ({
              margin: "1px",
              fontSize: "16px",
              paddingRight: "10px",
            })}
            cellStyle={(x, y, ratio) => ({
              margin: "1px",
              background: getColorFromRatio(ratio),
              border: ratio === 0 ? "1px solid #e2e2e2" : "",
              borderRadius: "0",
            })}
            cellHeight="25px"
            xLabelsPos="bottom"
            square
          />
        </GraphicSizeDiv>
        <AxisX>{t("reports.frequencyGraphic.axisX")}</AxisX>
      </GraphicRotateDiv>
    </GraphicContainer>
  );
});

export default FrequencyPlot;
